import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { NonAuthRoutes, Modules, RoleCodes } from '../../enums';
import { AuthContext } from '../../contexts/AuthContext';
import { Permissions } from '../../interfaces/common';
import { hasResourseAccess } from '../../utils/methods';
import Layout from '../Layout/Private';

interface ProtectedRouteProps {
  component: any;
  accessibleTo?: Permissions[];
  blockedRoles?: RoleCodes[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, accessibleTo, blockedRoles }) => {
  const Component = component;
  const {
    token, permissions, isSystemAdmin, loggedInUser
  } = useContext(AuthContext);

  if (!token) {
    return <Navigate replace to={{ pathname: Modules.auth + NonAuthRoutes.login }} />;
  }

  if (blockedRoles?.length && loggedInUser?.role_code && blockedRoles.includes(loggedInUser.role_code as RoleCodes)) {
    return <Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.forbidden }} />;
  }

  if (!hasResourseAccess(isSystemAdmin, permissions, accessibleTo ? { accessibleTo } : null)) {
    return <Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.forbidden }} />;
  }

  return (
    <Layout>
      <Component />
    </Layout>
  );
};

export default ProtectedRoute;
